const SUBMIT_RESET = 'SUBMIT_RESET';

const submitReset = () => ({
  type: SUBMIT_RESET
});

export {
  SUBMIT_RESET,
  submitReset,
}



// WEBPACK FOOTER //
// ./src/redux/actions/submit.js